export enum FileTypes {
  INITIATION = "INITIATION",
  EVALUATION = "EVALUATION",
  JUSTIFICATION_RESIDUAL_RISK = "JUSTIFICATION_RESIDUAL_RISK",
  RECOMMENDATION_FILES = "RECOMMENDATION_FILES",
  MODIFICATION_ASSESSMENT = "MODIFICATION_ASSESSMENT",
  MITIGATION = "MITIGATION",
  REASSESSMENT = "REASSESSMENT",
  JUSTIFICATION_FILES = "JUSTIFICATION_FILES",
  RECOMMENDATION_MITIGATION_PROTOCOL_FILES = "RECOMMENDATION_MITIGATION_PROTOCOL_FILES",
}
